import { createActions } from 'reduxsauce'

const { Types, Creators } = createActions({
  operatorUserLogin: ['email', 'password'],
  operatorUserLoginLoading: null,
  operatorUserLoginSuccess: ['loginData'],
  operatorUserLoginFail: null,
  operatorUserLoginResetClientState: null,

  resetPassVerification: ['email', 'onSuccess'],
  resetPassVerificationLoading: null,
  resetPassVerificationSuccess: ['emailID'],
  resetPassVerificationFail: ['error'],

  resetPass: [
    'newPassword',
    'emailVerificationCode',
    'emailVerificationId',
    'onSuccess',
  ],
  resetPassLoading: null,
  resetPassSuccess: null,
  resetPassFail: ['error'],

  fetchOperatorUser: null,
  fetchOperatorUserLoading: null,
  fetchOperatorUserSuccess: ['operatorUser'],
  fetchOperatorUserFail: ['error'],

  setAuthToken: ['token'],
  operatorUserLogout: null,

  onTwoFactorVerify: ['token', 'challengeId'],
  onTwoFactorVerifySuccess: ['token', 'refreshToken', 'operatorUser'],
  onTwoFactorVerifyFail: null,

  onTwoFactorSetupVerify: ['token', 'challengeId'],
  onTwoFactorSetupVerifySuccess: null,
  onTwoFactorSetupVerifyFail: null,
})

export const AuthTypes = Types
export default Creators
